import { render, staticRenderFns } from "./tab-certificado.vue?vue&type=template&id=48ff0a54&"
import script from "./tab-certificado.vue?vue&type=script&lang=js&"
export * from "./tab-certificado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports